module.exports = __webpack_public_path__ + "img/default-avatar-linkcard.9d7a996.png";